<template>
  <div class="hello">
    <h3>{{tag_line}}</h3>
    <img src="../assets/1-commitment-swear.jpg">
    <div class="content">

    </div>

    <md-button v-on:click="logout" >Logout</md-button>
  </div>
</template>

<script>

import firebase from 'firebase'

export default {
  name: 'HelloWorld',
  data: function () {
    return {
      tag_line: 'The first step to simply keeping commitments.'
    }
  },
  methods: {
    logout: function () {
      firebase.auth().signOut().then(() => {
        this.$router.replace('login')
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Hello.vue